import { Check, Pencil, Send, Trash2 } from "lucide-react";
import { useT } from "../i18n";
import StatusBadge from "./StatusBadge";

const btnBase = "flex items-center gap-1.5 text-xs font-semibold px-3.5 py-2 rounded-full";

export default function AdminProRow({ pro, locale, onEdit, onApprove, onDelete, onNudge }) {
  const { t } = useT();
  return (
    <article data-testid={`admin-pro-row-${pro.id}`}
      className="bg-white rounded-xl border border-black/5 p-5 flex flex-col gap-3">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-bold text-[#1F2937]" style={{ fontFamily: "Manrope" }}>
            {pro.name}
            {!pro.approved && (
              <span data-testid={`admin-pending-${pro.id}`} className="ml-2 text-[10px] uppercase tracking-[0.15em] font-semibold text-[#92400E] bg-[#FEF3C7] border border-[#FBBF24] rounded-full px-2 py-0.5">
                {t("admin.pending")}
              </span>
            )}
          </h3>
          <p className="text-xs uppercase tracking-[0.15em] text-[#0D4045] font-semibold mt-1">
            {t(`specialty.${pro.specialty}`)} — {pro.commune}
          </p>
        </div>
        <StatusBadge status={pro.status} testid={`admin-status-${pro.id}`} />
      </div>
      <p className="text-xs text-[#6B7280]">
        {t("card.updated")} {new Date(pro.status_updated_at).toLocaleDateString(locale)}
        {pro.contact_email ? ` — ${pro.contact_email}` : ""}
      </p>
      <p data-testid={`admin-consent-${pro.id}`} className={`text-xs font-semibold ${pro.consent_at ? "text-[#065F46]" : "text-[#92400E]"}`}>
        {pro.consent_at ? `${t("admin.consent.on")} ${new Date(pro.consent_at).toLocaleDateString(locale)}` : t("admin.consent.none")}
      </p>
      <div className="flex flex-wrap gap-2">
        {!pro.approved && (
          <button data-testid={`admin-approve-${pro.id}`} onClick={() => onApprove(pro)}
            className={`${btnBase} bg-[#D1FAE5] text-[#065F46] border border-[#34D399] hover:opacity-80 transition-opacity duration-200`}>
            <Check size={13} /> {t("admin.approve")}
          </button>
        )}
        <button data-testid={`admin-edit-${pro.id}`} onClick={() => onEdit(pro)}
          className={`${btnBase} bg-[#E8F3F1] text-[#0D4045] hover:bg-[#d7eae6] transition-colors duration-200`}>
          <Pencil size={13} /> {t("admin.edit")}
        </button>
        {pro.status === "a_confirmer" && pro.contact_email && (
          <button data-testid={`admin-nudge-${pro.id}`} onClick={() => onNudge(pro)}
            className={`${btnBase} bg-[#FEF3C7] text-[#92400E] border border-[#FBBF24] hover:opacity-80 transition-opacity duration-200`}>
            <Send size={13} /> {t("admin.nudge")}
          </button>
        )}
        <button data-testid={`admin-delete-${pro.id}`} onClick={() => onDelete(pro)}
          className={`${btnBase} bg-[#FEE2E2] text-[#991B1B] hover:opacity-80 transition-opacity duration-200`}>
          <Trash2 size={13} /> {t("admin.delete")}
        </button>
      </div>
    </article>
  );
}
